import { render, staticRenderFns } from "./SetUpSignature.vue?vue&type=template&id=a1cc6a0c&scoped=true&"
import script from "./SetUpSignature.vue?vue&type=script&lang=js&"
export * from "./SetUpSignature.vue?vue&type=script&lang=js&"
import style0 from "./SetUpSignature.vue?vue&type=style&index=0&id=a1cc6a0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cc6a0c",
  null
  
)

export default component.exports